import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance, ref } from 'vue';
import RecordForm from '@blade-sxp/monitoring-center/pages/record/components/record-form.vue';
import RecordList from '@blade-sxp/monitoring-center/pages/record/components/record-list.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const route = getCurrentInstance()?.proxy?.$route;
        const queryParams = JSON.parse(route?.query?.params);
        const recordTable = ref(null);
        const updateData = (formParams) => {
            recordTable.value.updateData(formParams);
        };
        const updateGroupTime = (formParams) => {
            recordTable.value.groupTimeChange(formParams);
        };
        return { __sfc: true, route, queryParams, recordTable, updateData, updateGroupTime, RecordForm, RecordList };
    }
});
